import classNames from 'classnames';
import { timeToClockFormat } from '@shared/utils/time';
import { DepartureOrArrival } from '@shared/models/departureOrArrival';
import styles from './DepartureOrArrivalTableTargetTimeCell.module.scss';
import { getHasChangedTargetClockTime } from '@shared/utils/departureOrArrival';

interface DepartureOrArrivalTableTargetTimeCellProps {
  departureOrArrival: DepartureOrArrival;
  headerWidth?: number;
}

export default function DepartureOrArrivalTableTargetTimeCell({
  departureOrArrival,
  headerWidth,
}: DepartureOrArrivalTableTargetTimeCellProps) {
  const targetTimeClock =
    departureOrArrival.targetTime !== undefined
      ? timeToClockFormat(departureOrArrival.targetTime)
      : undefined;

  const hasChangedTargetClockTime =
    getHasChangedTargetClockTime(departureOrArrival);

  return (
    <td className={styles['next-target']} style={{ minWidth: headerWidth }}>
      {targetTimeClock && (
        <time
          className={classNames(
            styles['target-time'],
            hasChangedTargetClockTime && styles['target-time--changed'],
          )}
        >
          {targetTimeClock}
        </time>
      )}
    </td>
  );
}
